import api from "../../services/api";

export const FETCH_GETBASKET_FULFILLED = "FETCH_GETBASKET_FULFILLED";
export const FETCH_GETBASKET_REJECTED = "FETCH_GETBASKET_REJECTED";
export const FETCH_GETBASKET_PENDING = "FETCH_GETBASKET_PENDING";
export const RESET_GETBASKET = "RESET_GETBASKET";


export function getBasket() {
  return (dispatch) => {
      dispatch({ type: FETCH_GETBASKET_PENDING });
      api.get("/gate/cart/get")
          .then(response => {
              dispatch({
                  type: FETCH_GETBASKET_FULFILLED,
                  payload: response.data,
              });
          })
          .catch(error => {
              dispatch({
                  type: FETCH_GETBASKET_REJECTED,
                  payload: error,
              });
          });
  };
}

export function getBasketReset() {
  return (dispatch) => {
      dispatch({
          type: RESET_GETBASKET,
      });
  };
}